import getAPI from "@API/index";

export const deleteClient = (id) => {
  return () =>
    getAPI().request({
      method: "delete",
      url: `/api/Client/${id}`,
    });
};
